module.exports = __webpack_public_path__ + "img/Vivian Figures.f8a1ec5f.jpg";